var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ReportTable',{attrs:{"data-props":_vm.dataProps,"custom-components":{ EventCell: _vm.EventCell, CarNumberCell: _vm.CarNumberCell }}})
}
var staticRenderFns = []

export { render, staticRenderFns }